var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keywords"},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.id,staticClass:"keyword",attrs:{"to":{query: {q: item.label}}}},[_c('img',{staticClass:"keyword-image",attrs:{"src":item.thumb,"alt":""}}),_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }